// extracted by mini-css-extract-plugin
module.exports = {"ChannelView":"Channel_ChannelView__3Mv0W"};